import Vue from 'vue';
import router from '@/router/init-router';

const RHandler = {};

const ERROR_DELAY = 3000;

const toastError = (message) => {
  Vue.toasted.error(message, {
    duration: ERROR_DELAY,
    icon: 'mdi-alert-circle-outline',
  });
};

export const appErrorHandler = (error, rOptions = {}) => {
  const { obs } = rOptions;
  let toasts = [];
  if (error?.response?.data) {
    const { data } = error.response;
    if (data.errors) toasts.push(...Object.values(data.errors));
    else if (data.data?.message) toasts.push(data.data.message);
    else toasts.push(`${error.response.status} - ${data.result_message || data.message || data}`);
  }

  if (error?.response?.data?.result_code === 'VAL01') {
    if (obs) obs.setErrors(error.response.data.validation);
    toasts = [];
    Object.values(error.response.data.validation).forEach(([err]) => {
      toasts.push(err);
    });
  }
  if (error?.response?.data?.result_code === 'NEUDT') {
    const { courseId } = router.currentRoute.params;
    router.push({
      name: 'UserRecordCourse',
      params: { courseId },
    });
  }

  if (rOptions && !rOptions.hideErrorToasts) {
    toasts.forEach((message) => {
      toastError(message);
    });
  }
};

// const ERROR_TEXT = 'Произошла непредвиденная ошибка, сообщите об ошибке администратору';

/*
 * rHandler(responseHandler) DEPRECATED
 *
 * Обработчик ошибок с бекенда,
 * обрабатывает промисы, принимая обязательную функцию,
 * которая возвращает промис, а также
 * принимает 3 необязательных функции:
 * 1. onSuccess - функция, которая будет вызвана в случае успешного запроса
 * 2. onReject - функция, которая будет вызвана в случае неудачного запроса
 * 3. validationObserver - реф на компонент VeeValidate. Нужен для установки ошибок валидации
 *
 * rHandler выводит ошибку из result_message по умолчанию в случае неудачного запроса,
 * Чтобы не выводить result_message - функция onReject должна возвращать любое значение,
 * кроме undefined.
 * Во всех остальных случаях по умолчанию result_message выводится
 */
export const rHandler = (
  request,
  onSuccess = () => {},
  onReject = () => {},
  validationObserver,
) => (
  request
    .then((response) => {
      if (response.data.result_code && response.data.result_code !== 'FLSCS') {
        const error = new Error('Запрос был обработан не успешно');
        error.response = response;
        throw error;
      }
      return onSuccess(response);
    })
    .catch((error) => {
      const errors = error?.response?.data?.errors;
      if (validationObserver && errors) validationObserver.setErrors(errors);

      onReject(error);
    })
);

RHandler.install = (VueInstance) => {
  VueInstance.rHandler = rHandler;
  VueInstance.prototype.$rHandler = rHandler;
};

export default RHandler;
